export default "__VITE_PUBLIC_ASSET__c8f6229e__"